  <template>
  <div>
    <div class="Banner">
      <img src="../../assets/qwwlwkxsjfw_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          积分商城
        </h1>
        <aside>
          Integral Mall
        </aside>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <h4>悦享互联提供标准化的积分商城业务。悦享互联拥有专业的技术团队，针对用户不同的兑换行为，协助客户定制专属的积分商城。
          </h4>
          <p>
            积分商城支持：
          </p>
          <aside class="text">
            积分管理服务<br>
            积分兑换服务 <br>
            商品上下架服务 <br>
            活动管理服务 <br>
            营销管理服务 <br>
            订单管理服务 <br>
            用户管理服务 <br>
            权限管理服务 <br>
            商品管理服务 <br>
            黑白名单服务<br>
          </aside>
        </div>
        <div class="col-sm-6 col-xs-12">
          <img src="../../assets/Sales_service_pic05.jpeg" style="margin-bottom: 30px" alt="">
          <img src="../../assets/Sales_service_pic04.jpeg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img{
  width: 100%;
}
.Banner {
  margin-bottom: 4rem;
}
h1 {
  font-size: 4.6rem;
  color: #fe9901;
}
aside {
  font-size: 1.6rem;
  color: #999;
  text-transform: uppercase;
}
.title {
  padding-left: 30px;
  border-left: 1px solid #ccc;
  margin-bottom: 4rem;
}
  h4 {
    color: #333;
    font-size: 1.8rem;
    text-indent: 30px;
    line-height: 35px;
    margin-bottom: 25px;
    font-weight: normal;
  }
  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: bold;
  }
  .text {
    color: #666;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: normal;
    padding-left: 30px;
  }
</style>
